module.exports = __webpack_public_path__ + "static/img/plan-5.7fef15dd.png";